/* Formularz wyceny — ogony.pl (v2 2026-08-15: jedna strona, bez krokow)
 *
 * Robi trzy rzeczy:
 *  1. Walidacja z komunikatami POD polem (system IKEA; link do planera LUB opis LUB zdjecia).
 *     Imie / e-mail / zgoda sa `required` natywnie — przegladarka pilnuje ich sama.
 *  2. Wgrywa zalaczniki (Cloudinary unsigned ALBO Google Apps Script) i wpisuje URL
 *     do ukrytych pol contact[Zalacznik N]. Bez SDK, czysty fetch. Zdjecia z telefonu
 *     zmniejsza w przegladarce do 2000 px.
 *  3. Przy submit sklada czytelna specyfikacje na poczatku contact[body], zeby mail
 *     otwieral sie blokiem gotowym do przeklejenia w arkusz wyceny; tekst klienta
 *     zostaje pod znacznikiem "--- uwagi klienta ---". Po przeladowaniu (blad Shopify)
 *     przywraca klientowi tylko jego tekst.
 */
(function () {
  'use strict';

  var root = document.querySelector('[data-wyc]');
  if (!root) return;

  var form = root.querySelector('.wyc__form');
  if (!form) return;
  if (!form.querySelector('[data-wyc-block]')) return; // ekran po wyslaniu

  var bodyField = form.querySelector('[data-wyc-body]');
  var planerField = form.querySelector('[data-wyc-planer]');
  var krajField = form.querySelector('[data-wyc-kraj]');
  var kolorField = form.querySelector('[name="contact[Kolor]"]');
  var vatBox = form.querySelector('[data-wyc-vat]');

  // Teksty w jezyku strony (PL/DE/EN) z sekcji, %N i %F = liczby
  var T = {};
  try { T = JSON.parse(form.querySelector('[data-wyc-i18n]').textContent); } catch (err) { T = {}; }
  function t(key, n, f) {
    return String(T[key] || '').replace('%N', n).replace('%F', f);
  }

  var MARK_START = 'ZGLOSZENIE Z FORMULARZA WYCENY';
  var MARK_NOTES = '--- uwagi klienta ---';
  var MARK_END = '--- koniec zgloszenia ---';   // koniec tekstu klienta dla automatu (Shopify dopisuje pod nim pola)
  var EMPTY_NOTES_PLACEHOLDER = '(brak)';

  var startedAt = Date.now();

  /* ---------------- Komunikaty pod polami ---------------- */

  function fieldBox(key) {
    return form.querySelector('[data-wyc-field="' + key + '"]');
  }

  function setMsg(key, msg) {
    var box = fieldBox(key);
    if (!box) return;
    var el = box.querySelector('[data-wyc-msg]');
    if (msg) {
      box.classList.add('wyc__field--invalid');
      if (el) { el.textContent = msg; el.hidden = false; }
    } else {
      box.classList.remove('wyc__field--invalid');
      if (el) { el.textContent = ''; el.hidden = true; }
    }
  }

  function focusBox(key) {
    var box = fieldBox(key);
    if (!box) return;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    // Horizon od 990 px przewija .page-wrapper, nie window - scrollIntoView trafia w kontener, który się przewija
    box.style.scrollMarginTop = '90px';
    box.scrollIntoView({ block: 'start', behavior: reduce ? 'auto' : 'smooth' });
    var input = box.querySelector('input:not([type="hidden"]), select, textarea');
    if (input) input.focus({ preventScroll: true });
  }

  function checked(name) {
    return form.querySelector('[name="contact[' + name + ']"]:checked');
  }

  /* ---------------- Walidacja ---------------- */

  function validate() {
    var firstBad = null;

    function need(key, ok, msgKey) {
      setMsg(key, ok ? '' : t(msgKey));
      if (!ok) firstBad = firstBad || key;
    }

    need('system', checked('System IKEA'), 'sys');
    need('styl', checked('Styl'), 'styl');
    need('kolor', kolorField && kolorField.value.trim(), 'kolor');

    var hasPlaner = planerField && planerField.value.trim();
    var hasBody = bodyField && bodyField.value.trim();
    var hasFiles = items.some(function (it) { return it.url; });
    need('body', hasPlaner || hasBody || hasFiles, 'body');

    need('kraj', krajField && krajField.value, 'kraj');
    need('klient', checked('Klient'), 'klient');

    if (firstBad) focusBox(firstBad);
    return !firstBad;
  }

  // Kasuj komunikat, gdy klient zaczyna poprawiac
  [['System IKEA', 'system'], ['Styl', 'styl'], ['Klient', 'klient']].forEach(function (pair) {
    Array.prototype.forEach.call(form.querySelectorAll('[name="contact[' + pair[0] + ']"]'), function (r) {
      r.addEventListener('change', function () { setMsg(pair[1], ''); });
    });
  });
  if (kolorField) kolorField.addEventListener('input', function () { setMsg('kolor', ''); });
  if (krajField) krajField.addEventListener('change', function () { setMsg('kraj', ''); });
  if (bodyField) bodyField.addEventListener('input', function () { setMsg('body', ''); });
  if (planerField) planerField.addEventListener('input', function () { setMsg('body', ''); });

  // Numer VAT UE tylko dla firmy; przy osobie prywatnej pole znika i sie czysci
  Array.prototype.forEach.call(form.querySelectorAll('[name="contact[Klient]"]'), function (r) {
    r.addEventListener('change', function () {
      if (!vatBox) return;
      var firma = r.checked && r.value === 'firma';
      vatBox.hidden = !firma;
      if (!firma) vatBox.querySelector('input').value = '';
    });
  });

  /* ---------------- Zalaczniki ---------------- */

  var cloud = root.getAttribute('data-cloud-name');
  var preset = root.getAttribute('data-upload-preset');
  var driveUrl = root.getAttribute('data-drive-endpoint');
  var driveToken = root.getAttribute('data-drive-token');
  var maxFiles = parseInt(root.getAttribute('data-max-files'), 10) || 5;
  var maxBytes = (parseInt(root.getAttribute('data-max-mb'), 10) || 10) * 1024 * 1024;

  // Cloudinary ma pierwszenstwo, jesli skonfigurowane sa obie drogi.
  var mode = (cloud && preset) ? 'cloudinary' : (driveUrl ? 'drive' : '');
  var uploadOn = !!mode;

  var dropZone = form.querySelector('[data-wyc-drop]');
  var fileInput = form.querySelector('[data-wyc-file]');
  var fileList = form.querySelector('[data-wyc-filelist]');
  var fileNote = form.querySelector('[data-wyc-filenote]');
  var fileFallback = form.querySelector('[data-wyc-filefallback]');
  var items = [];

  // noteKind pilnuje, zeby komunikat ustawiony przy wyborze plikow (np. limit sztuk)
  // nie zostal skasowany przez zakonczony upload innego pliku.
  var noteKind = null;

  function note(msg, kind) {
    if (!fileNote) return;
    if (!msg) {
      fileNote.hidden = true;
      fileNote.textContent = '';
      fileNote.classList.remove('wyc__filenote--info');
      noteKind = null;
      return;
    }
    fileNote.hidden = false;
    fileNote.textContent = msg;
    fileNote.classList.toggle('wyc__filenote--info', kind === 'info');
    noteKind = kind || 'info';
  }

  function pendingUploads() {
    return items.filter(function (it) { return it.state === 'up'; }).length;
  }

  // Bez tego dalo sie kliknac Wyslij w trakcie wgrywania i zgloszenie szlo
  // z pustym polem Zalacznik — plik przepadal po cichu.
  function syncSubmitState() {
    var btn = form.querySelector('[data-wyc-submit]');
    if (!btn) return;
    var czeka = pendingUploads() > 0;
    btn.disabled = czeka;
    btn.textContent = czeka ? t('waitbtn') : t('send');
  }

  function syncFileFields() {
    syncSubmitState();
    var ok = items.filter(function (it) { return it.url; });
    for (var n = 1; n <= maxFiles; n++) {
      var out = form.querySelector('[data-wyc-fileout="' + n + '"]');
      if (out) out.value = ok[n - 1] ? ok[n - 1].url : '';
    }
    var failed = items.some(function (it) { return it.state === 'err'; });
    if (fileFallback) {
      fileFallback.value = failed ? 'Tak, klient ma pliki, ktorych nie udalo sie wgrac' : '';
    }
    if (failed) {
      note(t('failed'), 'upload');
    } else if (noteKind === 'upload') {
      note('');
    }
    if (ok.length) setMsg('body', '');
  }

  function renderItem(it) {
    var li = document.createElement('li');
    li.className = 'wyc__fileitem';
    li.setAttribute('data-state', it.state);

    if (it.file.type.indexOf('image/') === 0) {
      var img = document.createElement('img');
      img.className = 'wyc__filethumb';
      img.alt = '';
      img.src = URL.createObjectURL(it.file);
      // HEIC z iPhone'a ma MIME image/*, ale poza Safari <img> go nie zdekoduje —
      // wtedy odpala sie 'error', nie 'load', wiec revoke musi byc w obu galeziach.
      img.addEventListener('load', function () { URL.revokeObjectURL(img.src); });
      img.addEventListener('error', function () { URL.revokeObjectURL(img.src); });
      li.appendChild(img);
    } else {
      var box = document.createElement('span');
      box.className = 'wyc__filethumb';
      li.appendChild(box);
    }

    var meta = document.createElement('span');
    meta.className = 'wyc__filemeta';
    var nameEl = document.createElement('span');
    nameEl.className = 'wyc__filename';
    nameEl.textContent = it.file.name;
    var statusEl = document.createElement('span');
    statusEl.className = 'wyc__filestatus';
    statusEl.textContent = t('up');
    meta.appendChild(nameEl);
    meta.appendChild(statusEl);
    li.appendChild(meta);

    var del = document.createElement('button');
    del.type = 'button';
    del.className = 'wyc__filedel';
    del.setAttribute('aria-label', t('del') + it.file.name);
    del.innerHTML = '&times;';
    del.addEventListener('click', function () {
      items = items.filter(function (x) { return x !== it; });
      li.parentNode.removeChild(li);
      syncFileFields();
    });
    li.appendChild(del);

    it.li = li;
    it.statusEl = statusEl;
    if (fileList) fileList.appendChild(li);
  }

  function toBase64(file) {
    return new Promise(function (resolve, reject) {
      var r = new FileReader();
      r.onload = function () {
        var s = String(r.result);
        var i = s.indexOf(',');
        resolve(i === -1 ? s : s.slice(i + 1));
      };
      r.onerror = reject;
      r.readAsDataURL(file);
    });
  }

  function sendToCloudinary(file) {
    var data = new FormData();
    data.append('file', file);
    data.append('upload_preset', preset);

    return fetch('https://api.cloudinary.com/v1_1/' + encodeURIComponent(cloud) + '/auto/upload', {
      method: 'POST',
      body: data
    })
      .then(function (res) {
        if (!res.ok) throw new Error('http ' + res.status);
        return res.json();
      })
      .then(function (json) {
        if (!json || !json.secure_url) throw new Error('brak secure_url');
        return json.secure_url;
      });
  }

  // Apps Script nie obsluguje preflightu OPTIONS, wiec wysylamy jako text/plain
  // (zadanie "proste" wg CORS) z JSON-em w ciele.
  function sendToDrive(file) {
    return toBase64(file)
      .then(function (b64) {
        return fetch(driveUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'text/plain;charset=utf-8' },
          body: JSON.stringify({
            token: driveToken || '',
            name: file.name,
            mime: file.type || 'application/octet-stream',
            data: b64
          })
        });
      })
      .then(function (res) {
        if (!res.ok) throw new Error('http ' + res.status);
        return res.json();
      })
      .then(function (json) {
        if (!json || !json.ok || !json.url) throw new Error((json && json.error) || 'brak url');
        return json.url;
      });
  }

  function upload(it) {
    var send = mode === 'cloudinary' ? sendToCloudinary : sendToDrive;

    return send(it.file)
      .then(function (url) {
        it.url = url;
        it.state = 'ok';
        it.statusEl.textContent = t('ok');
      })
      .catch(function () {
        it.state = 'err';
        it.statusEl.textContent = t('err');
      })
      .then(function () {
        it.li.setAttribute('data-state', it.state);
        syncFileFields();
      });
  }

  // Zdjecia z telefonu potrafia wazyc 10-15 MB. Zmniejszamy je w przegladarce
  // przed wyslaniem — do oceny koloru i ukladu kuchni 2000 px w zupelnosci wystarcza,
  // a upload przestaje byc waskim gardlem na komorkowym internecie.
  // HEIC nie dekoduje sie poza Safari — wtedy po cichu wracamy do oryginalu.
  function prepareFile(file) {
    if (file.type.indexOf('image/') !== 0) return Promise.resolve(file);
    if (file.size <= 900 * 1024) return Promise.resolve(file);

    return new Promise(function (resolve) {
      var img = new Image();
      var url = URL.createObjectURL(file);

      img.onload = function () {
        URL.revokeObjectURL(url);
        try {
          var max = 2000;
          var scale = Math.min(1, max / Math.max(img.width, img.height));
          var w = Math.max(1, Math.round(img.width * scale));
          var h = Math.max(1, Math.round(img.height * scale));
          var canvas = document.createElement('canvas');
          canvas.width = w;
          canvas.height = h;
          canvas.getContext('2d').drawImage(img, 0, 0, w, h);
          canvas.toBlob(function (blob) {
            if (!blob || blob.size >= file.size) return resolve(file);
            var name = file.name.replace(/\.[^.]+$/, '') + '.jpg';
            resolve(new File([blob], name, { type: 'image/jpeg' }));
          }, 'image/jpeg', 0.85);
        } catch (err) {
          resolve(file);
        }
      };
      img.onerror = function () {
        URL.revokeObjectURL(url);
        resolve(file);
      };
      img.src = url;
    });
  }

  function addFiles(list) {
    var incoming = Array.prototype.slice.call(list);
    if (!incoming.length) return;

    var free = maxFiles - items.length;
    if (free <= 0) {
      note(t('limit', maxFiles), 'limit');
      return;
    }
    if (incoming.length > free) {
      note(t('partial', maxFiles, free), 'limit');
    }

    incoming.slice(0, free).forEach(function (file) {
      var it = { file: file, url: '', state: 'up' };
      items.push(it);
      renderItem(it);
      syncSubmitState();

      prepareFile(file).then(function (prepared) {
        if (prepared.size > maxBytes) {
          it.state = 'err';
          it.statusEl.textContent = t('big', Math.round(maxBytes / 1048576));
          it.li.setAttribute('data-state', 'err');
          syncFileFields();
          return;
        }
        it.file = prepared;
        return upload(it);
      });
    });
  }

  if (dropZone && fileInput) {
    if (!uploadOn) {
      dropZone.hidden = true;
      note(t('noup'), 'info');
    } else {
      fileInput.addEventListener('change', function () {
        addFiles(fileInput.files);
        fileInput.value = '';
      });

      ['dragenter', 'dragover'].forEach(function (evt) {
        dropZone.addEventListener(evt, function (e) {
          e.preventDefault();
          dropZone.classList.add('wyc__drop--over');
        });
      });
      ['dragleave', 'drop'].forEach(function (evt) {
        dropZone.addEventListener(evt, function (e) {
          e.preventDefault();
          dropZone.classList.remove('wyc__drop--over');
        });
      });
      dropZone.addEventListener('drop', function (e) {
        if (e.dataTransfer && e.dataTransfer.files) addFiles(e.dataTransfer.files);
      });
    }
  }

  /* ---------------- Podsumowanie do maila ---------------- */

  function currentNotes() {
    if (!bodyField) return '';
    var v = bodyField.value || '';
    if (v.indexOf(MARK_START) === 0) {
      var i = v.indexOf(MARK_NOTES);
      if (i === -1) return '';
      var extracted = v.slice(i + MARK_NOTES.length);
      var e = extracted.indexOf(MARK_END);
      if (e !== -1) extracted = extracted.slice(0, e);
      extracted = extracted.trim();
      // Jesli klient nic nie wpisal, composeBody() wstawil placeholder "(brak)".
      // Po przeladowaniu strony (np. blad e-maila) nie chcemy wstawiac tego literalnego
      // tekstu z powrotem do pustego pola, ktore klient nigdy nie wypelnil.
      return extracted === EMPTY_NOTES_PLACEHOLDER ? '' : extracted;
    }
    return v.trim();
  }

  // Blok wg ~/ogony-ops/automat/KONTRAKT.md §1: stale klucze w stalej kolejnosci,
  // jedna linia na pole, brak wartosci = "-". Czyta go automat wycen.
  function val(name) {
    var c = checked(name);
    if (c) return c.value;
    var el = form.querySelector('[name="contact[' + name + ']"]:not([type="radio"])');
    return el ? el.value : '';
  }

  function line(key, v) {
    v = String(v || '').replace(/\s+/g, ' ').trim();
    return key + ': ' + (v || '-');
  }

  function newId() {
    function p(n) { return (n < 10 ? '0' : '') + n; }
    var d = new Date();
    var rnd = (Math.random().toString(36) + '0000').slice(2, 6);
    return 'WYC-' + d.getFullYear() + p(d.getMonth() + 1) + p(d.getDate()) + '-' +
      p(d.getHours()) + p(d.getMinutes()) + p(d.getSeconds()) + '-' + rnd;
  }

  function buildBlock() {
    var files = items.filter(function (it) { return it.url; }).map(function (it) { return it.url; });
    return [
      MARK_START,
      line('ID', newId()),
      line('Jezyk', root.getAttribute('data-jezyk')),
      line('Rynek', root.getAttribute('data-rynek')),
      line('Kraj dostawy', val('Kraj dostawy')),
      line('Klient', val('Klient')),
      line('VAT UE', val('Klient') === 'firma' ? val('VAT UE') : ''),
      line('System IKEA', val('System IKEA')),
      line('Styl', val('Styl')),
      line('Kolor', val('Kolor')),
      line('Link planer', val('Link planer')),
      line('Zalaczniki', files.join('; ')),
      line('Pliki do doslania', fileFallback && fileFallback.value ? 'tak' : ''),
      line('Imie', val('name')),
      line('Email', val('email')),
      line('Telefon', val('phone'))
    ];
  }

  function composeBody() {
    if (!bodyField) return;
    var notes = currentNotes();
    bodyField.value = buildBlock().join('\n') + '\n' + MARK_NOTES + '\n' + (notes || EMPTY_NOTES_PLACEHOLDER) + '\n' + MARK_END;
  }

  /* ---------------- Start ---------------- */

  root.classList.add('wyc--js');

  // Po bledzie walidacji Shopify przeladowuje strone z body = zlozona specyfikacja.
  // Pokazujemy klientowi z powrotem tylko jego wlasny tekst.
  if (bodyField) bodyField.value = currentNotes();

  // Nasza walidacja (gora formularza) ma isc PRZED natywna (imie/e-mail/zgoda na dole) —
  // inaczej przegladarka najpierw pokaze dymek przy e-mailu, a dopiero po jego poprawieniu
  // odeslalibysmy klienta z powrotem na gore do systemu IKEA.
  var submitBtn = form.querySelector('[data-wyc-submit]');
  if (submitBtn) {
    submitBtn.addEventListener('click', function (e) {
      if (!validate()) e.preventDefault();
    });
  }

  form.addEventListener('submit', function (e) {
    var hp = form.querySelector('[name="wyc_hp"]');
    if (hp && hp.value) {
      e.preventDefault();
      return;
    }
    if (Date.now() - startedAt < 4000) {
      e.preventDefault();
      return;
    }
    if (pendingUploads() > 0) {
      e.preventDefault();
      note(t('wait'), 'upload');
      return;
    }
    if (!validate()) {
      e.preventDefault();
      return;
    }
    composeBody();
  });
})();
